import React, { useState } from 'react';
import { Box, Typography, useTheme, Button } from '@mui/material';
import { useThemeContext } from './theme/ThemeContext';
import BasicModal from './modais/BasicModal';
import ReactPlayer from 'react-player';
import { Info } from '@mui/icons-material';

interface InfoHeaderProps {
  title: string;
  message: string;
  isImportant: boolean;
  url?: string;
  modalTitle?: string;
}

const InfoHeader: React.FC<InfoHeaderProps> = ({ title, message, isImportant, url, modalTitle }) => {
  const theme = useTheme();
  const { toggleTheme, mode } = useThemeContext();
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  return (
    <Box
      sx={{
        maxWidth: '100%',
        padding: '0px 0px 20px 0px',
        margin: theme.spacing(1, 0),
      }}
    >
      <Box sx={{ display: 'flex', gap: 1.5 }}>
        <Typography
          variant="h5"
          component="h2"
          sx={{
            fontWeight: 'bold',
            textAlign: 'left',
            marginBottom: theme.spacing(1),
            color: mode === "light" ? theme.palette.primary.main : '#fff'
          }}
        >
          {title}
        </Typography>
        {url && modalTitle && (
          <Button
            variant="contained"
            sx={{
              height: 30,
              minWidth: 0,
              paddingInline: '8px',
              paddingBlock: '12px',
              borderRadius: 1.8
            }}
            onClick={() => setIsVideoModalOpen(true)}
          >
            <Info sx={{ fontSize: 16 }} />
          </Button>
        )}
      </Box>
      <Typography
        component="p"
        sx={{
          textAlign: 'left',
          fontSize: theme.typography.body1.fontSize,
          lineHeight: 1.6,
          color: theme.palette.text.primary,
        }}
      >
        {isImportant && (
          <span style={{
            color: theme.palette.error.main,
            fontWeight: 'bold',
            marginRight: theme.spacing(0.5)
          }}>
            Importante:
          </span>
        )}
        {message}
      </Typography>

      {url && modalTitle && (
        <BasicModal
          title={modalTitle}
          open={isVideoModalOpen}
          onClose={() => setIsVideoModalOpen(false)}
          sizeContent="medium"
        >
          <Box sx={{ position: 'relative', paddingTop: '56.2%' }}>
            <ReactPlayer
              url={url}
              width='100%'
              height='100%'
              style={{ position: 'absolute', top: 0, left: 0 }}
              controls
            />
          </Box>
        </BasicModal>
      )}
    </Box>
  );
};

export default InfoHeader;